(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aiheader"] && !window.DesignMode) return;
  try {
    
class DynamicHeader {
  constructor() {
    this.header = document.getElementById('dynamic-header');
    this.mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    this.mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    
    this.lastScrollY = 0;
    this.ticking = false;
    this.currentTheme = 'transparent';
    this.scrollDirection = 'up';
    this.headerHeight = 80;
    
    if (!this.header) {
      console.warn('Dynamic header not found');
      return;
    }
    
    this.init();
  }

  init() {
    this.setupScrollListener();
    this.setupSectionDetection();
    this.setupMobileMenu();
    this.setupBookNowButton();
    this.detectInitialTheme();
  }

  // FIXED: Simple scroll-based detection
  setupScrollListener() {
    let scrollTimer = null;
    
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
      
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (this.scrollDirection === 'down' && window.scrollY > 200) {
          this.header.classList.add('header-hidden');
          this.header.classList.remove('header-visible');
        }
      }, 150);
    });
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    
    // Determine scroll direction
    this.scrollDirection = currentScrollY > this.lastScrollY ? 'down' : 'up';
    
    if (currentScrollY < 50) {
      // At top - always show
      this.header.classList.remove('header-hidden');
      this.header.classList.add('header-visible');
    } else if (this.scrollDirection === 'up') {
      // Scrolling up - show header
      this.header.classList.remove('header-hidden');
      this.header.classList.add('header-visible');
    }
    
    this.lastScrollY = currentScrollY;
    
    // WORKING: Background detection on scroll
    this.detectCurrentSectionTheme();
  }

  // CORRECTED: Scroll-based section detection
  setupSectionDetection() {
    // Use scroll position to determine which section is under header
    window.addEventListener('scroll', () => {
      this.detectCurrentSectionTheme();
    });
  }

  detectCurrentSectionTheme() {
    const scrollY = window.scrollY;
    const headerBottom = this.headerHeight;
    const sections = document.querySelectorAll('.shopify-section');
    
    let activeSection = null;
    
    // Find which section is currently under the header
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + scrollY;
      const sectionBottom = rect.bottom + scrollY;
      
      if (sectionTop <= scrollY + headerBottom && sectionBottom >= scrollY + headerBottom) {
        activeSection = section;
      }
    });
    
    if (activeSection) {
      this.analyzeSection(activeSection);
    }
  }

  analyzeSection(section) {
    // Check for manual theme override first
    const manualTheme = section.dataset.headerTheme;
    if (manualTheme) {
      this.setTheme(manualTheme);
      return;
    }

    // Get computed styles
    const computedStyle = window.getComputedStyle(section);
    let backgroundColor = computedStyle.backgroundColor;
    const backgroundImage = computedStyle.backgroundImage;
    
    // Check if this is likely a hero/banner section (first section with background image)
    const isFirstSection = section === document.querySelector('.shopify-section');
    if (isFirstSection && window.scrollY < 100) {
      this.setTheme('transparent');
      return;
    }
    
    // If section has background image and no solid color, default based on position
    if (backgroundImage && backgroundImage !== 'none' && (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)')) {
      // For sections with images, use light theme for better contrast
      this.setTheme('light');
      return;
    }
    
    // If no background color, check parent or use scroll position logic
    if (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent') {
      // Check parent element
      const parent = section.parentElement;
      if (parent) {
        backgroundColor = window.getComputedStyle(parent).backgroundColor;
      }
      
      // Still no color? Use scroll-based logic
      if (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent') {
        // If we're past the first section and have no detected color, assume light
        this.setTheme(window.scrollY > window.innerHeight ? 'light' : 'transparent');
        return;
      }
    }
    
    // Analyze color luminance
    const theme = this.getThemeFromColor(backgroundColor);
    this.setTheme(theme);
  }

  getThemeFromColor(colorString) {
    const rgb = colorString.match(/\d+/g);
    if (!rgb || rgb.length < 3) return 'light'; // Default to light if can't parse
    
    const [r, g, b] = rgb.map(Number);
    
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Light background = dark text header (light theme)
    // Dark background = light text header (dark theme)
    return luminance > 0.7 ? 'light' : 'dark';
  }

  setTheme(theme) {
    if (this.currentTheme === theme) return;
    
    // Remove all theme classes
    this.header.classList.remove('header-transparent', 'header-light', 'header-dark');
    
    // Add new theme class
    this.header.classList.add(`header-${theme}`);
    
    this.currentTheme = theme;
    
    // Debug log
    console.log(`Header theme changed to: ${theme}`);
  }

  // Mobile menu and other functions remain the same...
  setupMobileMenu() {
    this.mobileMenuToggle.addEventListener('click', () => {
      this.toggleMobileMenu();
    });

    this.mobileMenuOverlay.addEventListener('click', (e) => {
      if (e.target === this.mobileMenuOverlay) {
        this.closeMobileMenu();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeMobileMenu();
      }
    });
  }

  toggleMobileMenu() {
    const isActive = this.mobileMenuToggle.classList.contains('active');
    
    if (isActive) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }

  openMobileMenu() {
    this.mobileMenuToggle.classList.add('active');
    this.mobileMenuOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeMobileMenu() {
    this.mobileMenuToggle.classList.remove('active');
    this.mobileMenuOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  setupBookNowButton() {
    const bookButtons = document.querySelectorAll('[href="#lead-capture-form"]');
    
    bookButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Close mobile menu if open
        if (this.mobileMenuOverlay.classList.contains('active')) {
          this.closeMobileMenu();
        }
        
        // Find lead capture form
        const leadForm = document.querySelector('[id*="lead-capture"]') || 
                        document.querySelector('.lead-capture') ||
                        document.getElementById('lead-capture-form');
        
        if (leadForm) {
          leadForm.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
          
          // Focus first input after scroll
          setTimeout(() => {
            const firstInput = leadForm.querySelector('input, textarea');
            if (firstInput) firstInput.focus();
          }, 800);
        }
      });
    });
  }

  detectInitialTheme() {
    // Initial theme detection
    setTimeout(() => {
      this.detectCurrentSectionTheme();
    }, 100);
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new DynamicHeader();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
